import {useSelector} from "react-redux";
import {State} from "@App/state";
import {useQuery} from "@apollo/client";
import {GaragePremiumServicesQuery, GET_GARAGE_PREMIUM_SERVICES} from "@App/graphql/queries";


export const usePremiumServices = () => {
    const organization = useSelector((state: State) => state.orders.organization)
    const service = useSelector((state: State) => state.orders.service)
    const garage = useSelector((state: State) => state.orders.garage)
    const driverID = useSelector((state: State) => state.auth?.driverData?.uuid)

    const {loading, data, error} = useQuery<GaragePremiumServicesQuery>(GET_GARAGE_PREMIUM_SERVICES, {
        variables: {
            organization: organization ? organization.id : null,
            garage: garage ? garage.id : null,
            services: service ? [service.id] : null,
            driverID: driverID,
        },
        fetchPolicy: 'no-cache',

        skip: !organization || !garage,
    })

    return {
        loading: loading,
        error: error,
        premiumServices: data ? data.organization.garages.data[0].premium_services : null,
    }
}


